const GRID_GAP = 12;

interface PlaceholderBackgroundProps {
  width: number;
  height: number;
  color: string;
}

export const PlaceholderBackground = ({
  width,
  height,
  color,
}: PlaceholderBackgroundProps) => {
  const rectWidth = width / 2 - GRID_GAP / 2;
  const rectHeight = height / 2 - GRID_GAP / 2;
  const rectProps = {
    width: rectWidth,
    height: rectHeight,
    fill: color,
    rx: 8,
    ry: 8,
  };
  return (
    <g>
      <rect x={0} y={0} {...rectProps} />
      <rect x={width / 2 + GRID_GAP / 2} y={0} {...rectProps} />
      <rect x={0} y={height / 2 + GRID_GAP / 2} {...rectProps} />
      <rect
        x={width / 2 + GRID_GAP / 2}
        y={height / 2 + GRID_GAP / 2}
        {...rectProps}
      />
    </g>
  );
};
